import Icon from '@ant-design/icons';
import { DTIProps, IMessengerChatSource } from '@xometry/ui';
import { ButtonProps } from 'antd';
import { ReactComponent as NoMessagesIconSVG } from 'assets/images/icons/messenger-no-messages.min.svg';
import clsx from 'clsx';
import { MessengerEntryPoint } from 'collections/amplitudeEvents';
import { AntButton } from 'components/ant/AntButton/AntButton';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import styles from './MessengerButton.module.less';
import { useMessengerButton } from './useMessengerButton';

interface IProps extends Partial<DTIProps> {
  context: IMessengerChatSource;
  entryPoint?: MessengerEntryPoint;
  height?: string;
  mt?: string;

  label?: React.ReactNode;
  padding?: string;
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
  type?: ButtonProps['type'];
  size?: ButtonProps['size'];
  'data-testid'?: string;
}

const MessengerButtonComponent: FC<IProps> = ({
  context,
  entryPoint,
  height = '20px',
  mt = '0',
  label = '',
  padding = '0',
  className,
  iconClassName,
  onClick,
  type = 'link',
  size = 'small',
  ...rest
}) => {
  const handleClick = useMessengerButton({ context, entryPoint, onClick });

  if (!context.sourceId || context.sourceId === 'undefined') {
    return null;
  }

  return (
    <AntButton
      {...rest}
      onClick={handleClick}
      type={type}
      size={size}
      style={{ padding, fontSize: height, marginTop: mt }}
      icon={<Icon component={NoMessagesIconSVG} style={{ fontSize: height }} className={iconClassName} />}
      className={clsx({
        [styles.button]: true,
        [String(className)]: Boolean(className),
      })}
    >
      {label}
    </AntButton>
  );
};

export const MessengerButton = observer(MessengerButtonComponent);
